import { userService } from "../services";
import config from "../config/config";
import { decryptAesObj } from "../components/CommonComponents/AESencryptdecrypt";

export const SiteAction = {
  fetchSiteList,
  addSiteAccess,
  removeSiteAccess,
  removeGeofench,
  fetchSiteRouteSubSite,
  fetchDplName,
};

async function fetchDplName(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${
      config.apiName.searchDplName
    }?companyId=${payload.companyId}&dplName=${payload.dplname}&userId=${
      decryptAesObj(localStorage.getItem("data")).id
    }`;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchSiteList(payload) {
  debugger
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.SiteList}?companyId=${
      payload.companyId
    }&status=${payload.status ? payload.status : ""}&userId=${
      decryptAesObj(localStorage.getItem("data")).id
    }&showSubSite=${
      payload.showSubSite == "false" ? false : true
    }&notFetchEmergencies=false&fetchCordinates=true`;
    let response = await userService.get(apiEndpoint);
    console.log("response.dataaaa", response.data);
    if (response && response.status == 200) {
      return response.data;
    } else {
      // alert("ji")
      console.log(response);
      alert(response.data.message);
      // alert("dfg");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchSiteRouteSubSite(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${
      config.apiName.routeSiteSubSite
    }?companyId=${payload.companyId}&showRoute=${payload.showRoute}&userId=${
      decryptAesObj(localStorage.getItem("data")).id
    }&showSubSite=${payload.showSubSite}`;
    let response = await userService.get(apiEndpoint);
    console.log(response,"szdxfcgvhbjnk");
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function removeGeofench(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${
      config.apiName.removeGeoFench
    }?companyId=${payload.companyId}&siteId=${
      payload.siteId ? payload.siteId : ""
    }&userId=${decryptAesObj(localStorage.getItem("data")).id}&subSiteId=${
      payload.subSiteId ? payload.subSiteId : ""
    }`;
    debugger;
    let response = await userService.get(apiEndpoint);
    console.log(response, "sxdcfvgbhnjmk");
    if (response && response.status === 200) {
      return response;
    } else {
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function addSiteAccess(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.AddSiteAccess}`;
    debugger;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function removeSiteAccess(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.RemoveSiteAccess}`;
    debugger;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
